<script lang="ts" setup>
    import BaseButton from '@/components/BaseButton.vue';
    import { useConfigStore } from '@/store/config.store';
    import { dataStore } from '@/commons/DataStore';
    import { computed } from 'vue';
    import { storeToRefs } from 'pinia';

    const emit = defineEmits<{
        sideChanged: [];
    }>();

    const { currentSide, displayGrid, isMobile } = storeToRefs(useConfigStore());
    const isRecto = computed(() => currentSide.value === 'recto');
    function switchSide(side: 'recto' | 'verso') {
        currentSide.value = side;
        emit('sideChanged');
        const currentFabricWorld = dataStore.getFabricWorld(side);
        currentFabricWorld.setGridHelperVisibility(displayGrid.value);
    }
</script>

<template>
    <div
        class="z-10 flex flex-row items-center justify-center"
        :class="[!isMobile && 'absolute right-2 top-12 z-10 mr-8 flex h-8 flex-row', isMobile && 'h-14']"
    >
        <BaseButton
            :variant="isRecto ? 'filled' : 'outlined'"
            class="h-full w-24 py-1"
            @click="switchSide('recto')"
        >
            {{ $t('Recto') }}
        </BaseButton>
        <BaseButton
            :variant="!isRecto ? 'filled' : 'outlined'"
            class="h-full w-24 py-1"
            @click="switchSide('verso')"
        >
            {{ $t('Verso') }}
        </BaseButton>
    </div>
</template>
